import { ArrowForwardIcon } from '@chakra-ui/icons'
import { Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, VStack, useDisclosure } from '@chakra-ui/react'
import { useRef } from 'react'
import { FaBars } from 'react-icons/fa6'
import { STEPS } from '../QuestionsPatienteView'
import { useAppSelector } from 'src/redux/hooks'

interface Props {
  step: number,
  setStep: React.Dispatch<React.SetStateAction<STEPS>>
}

const CategoriesMenuBar: React.FC<Props> = ({ step, setStep }) => {
  const {categories} = useAppSelector((state)=>state.question)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = useRef<any>()

  const setCategory = (index:number) => {
    setStep(index)
  }

  return (
    <Box display={{ base: 'block', xl: 'none' }} mb={4}>
      <Button ref={btnRef} variant='ghost' onClick={onOpen}>
        <FaBars className='text-3xl' />
      </Button>
      <Drawer
        isOpen={isOpen}
        placement='left'
        onClose={onClose}
        finalFocusRef={btnRef}
        size={{ base: 'xs', md: 'md' }}
      >
        <DrawerOverlay />
        <DrawerContent  >
          <DrawerCloseButton />
          <DrawerHeader>Categories</DrawerHeader>
          <DrawerBody >
            <VStack alignItems='flex-start' >
              {categories && categories?.length > 0 && categories?.map((c, index) => (
                <Button
                  key={index}
                  rightIcon={<ArrowForwardIcon />}
                  colorScheme={step === index ? 'blue' : 'gray'}
                  variant='ghost'
                  onClick={() => setCategory(c.id)}
                >
                  {c.categ}
                </Button>
              ))}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

    </Box>
  )
}

export default CategoriesMenuBar